export const SUBSCRIPTION_TIERS = {
    BASIC: 'basic',
    PREMIUM: 'premium',
    EXCLUSIVE: 'exclusive',
    BUSINESS: 'business',
    EMPLOYEE: 'employee',
    SUNSET_POINTS: 'sunsetpoints',
};
const normalizePlanName = (planName) => {
    if (!planName)
        return undefined;
    const trimmed = `${planName}`.trim();
    return trimmed.length ? trimmed : undefined;
};
export const getSubscriptionPlanKey = (planName) => {
    const raw = normalizePlanName(planName);
    if (!raw)
        return undefined;
    return raw.replace(/^sunsetplus\s+/i, '').replace(/\s+/g, '');
};
export const getSubscriptionPriceRuleLabel = (planName) => {
    const raw = normalizePlanName(planName);
    if (!raw)
        return undefined;
    return raw.replace(/\s+/g, '');
};
export const isAnnualSubscriptionPlan = (planName) => {
    const raw = normalizePlanName(planName);
    return Boolean(raw && raw.toLowerCase().includes('annual'));
};
export const getSubscriptionTier = (planName) => {
    const raw = normalizePlanName(planName);
    if (!raw)
        return undefined;
    const normalized = raw.toLowerCase().replace(/[^a-z]/g, '');
    if (!normalized)
        return undefined;
    if (normalized.includes('sunsetpoints'))
        return SUBSCRIPTION_TIERS.SUNSET_POINTS;
    if (normalized.includes('employee'))
        return SUBSCRIPTION_TIERS.EMPLOYEE;
    if (normalized.includes('business'))
        return SUBSCRIPTION_TIERS.BUSINESS;
    if (normalized.includes('exclusive'))
        return SUBSCRIPTION_TIERS.EXCLUSIVE;
    if (normalized.includes('premium'))
        return SUBSCRIPTION_TIERS.PREMIUM;
    if (normalized.includes('basic'))
        return SUBSCRIPTION_TIERS.BASIC;
    return undefined;
};
